import { getUnreadCount } from '../services/notifications'

// Tallet i varselbjella, delt av alle bjellene som er montert.
//
// Menyen har to bjeller (bred og smal) og bytter mellom dem hver gang den
// glir ut og inn. Hver montering hentet tallet på nytt, og det gjorde også
// hvert sidebytte: i produksjon tre kall på tre sekunder fra én bruker, hvert
// med en full innloggingssjekk på serveren. Nå hentes tallet høyst hvert
// 15. sekund, uansett hvor mange bjeller som ber om det. Det som må ha et
// ferskt tall med en gang (et varsel er lest), ber om det med `tving`.

const MINST_MELLOM_MS = 15_000

let sisteTall = 0
let sistHentet = 0
let pagaende = null
const lyttere = new Set()

export function sisteUleste() {
  return sisteTall
}

export function abonnerUleste(lytter) {
  lyttere.add(lytter)
  return () => { lyttere.delete(lytter) }
}

export function oppdaterUleste({ tving = false, naa = Date.now() } = {}) {
  // Et kall som alt er i gang, kan ha startet før varselet ble lest.
  if (pagaende) return tving ? pagaende.then(() => oppdaterUleste({ tving: true })) : pagaende
  if (!tving && naa - sistHentet < MINST_MELLOM_MS) return Promise.resolve(sisteTall)
  sistHentet = naa
  pagaende = getUnreadCount()
    .then((antall) => {
      sisteTall = antall
      for (const lytter of lyttere) lytter(antall)
      return antall
    })
    .catch(() => sisteTall)
    .finally(() => { pagaende = null })
  return pagaende
}

// Bare for testene.
export function glemUleste() {
  sisteTall = 0
  sistHentet = 0
  pagaende = null
  lyttere.clear()
}
